import './sass/main.scss';
import './js/teamLightbox';
import './js/switch-theme/switch-theme';
import './js/galleryRender/myLibRender';
import { addBackToTop } from 'vanilla-back-to-top';

addBackToTop();
